<template>
    <div>
        <v-layout wrap justify-center align-center>
            <v-flex md7 sm7 xs12>
                <dialogos-app :dialogos="dialogos" tucan="0"></dialogos-app>
            </v-flex>
        </v-layout>
        <v-layout wrap row justify-center align-center text-xs-center pb-5 class="cont_page">
          <v-flex xs12 sm7 md7>
            <div class="cont-num"><p>{{onboardingA+1}} / 14</p></div>
          </v-flex>
          <v-flex xs12 sm7 md7>
            <v-card flat tile color="transparent" class="cont-drop">
               <v-card-actions class="cont-btn-nextprev" reverse>
                <div class="btn-slide-prev hvr" fab small @click="prevA" v-show="verprv">
                  <v-icon color="#5A8B34" size="40">navigate_before</v-icon>
                </div>
                <div class="btn-slide-next hvr" fab small @click="nextA" v-show="vernxt">
                  <v-icon color="#5A8B34" size="40">navigate_next</v-icon>
                </div>
              </v-card-actions>
              <v-window v-model="onboardingA" touchless>
                  <v-window-item  v-for="(dropItem, index) in dropList" :key="'item'+index">
                     <div class="cont-titulo-slide" :ref="'toolitem-'+index" @click="openTool(index)" :class="{'tool-hover':classHover}">
                       <p>{{textDrop[onboardingA]}} </p>
                       <v-icon color="#FFF" v-if="classHover" class="icon-modal">add_box</v-icon>
                     </div>
                     <!-- dropables -->
                     <div>
                      <draggable v-model="dropList[index]" @change="change($event, index)" 
                      :options="{group:{ name:'items', put:!todosCorrectos[index]}}" class="item-cont">
                        <p v-for="element in dropList[index]" :key="element"
                        class="item-drop"><span v-html="element"></span></p>
                      </draggable>
                     </div>
                  </v-window-item>
              </v-window>
            </v-card>
          </v-flex>

          <v-flex xs12 md7 sm7 mt-1 v-if="mostrarBotones">
            <!-- <v-card flat tile color="transparent" class="cont-drags">
              <v-card-actions class="cont-btn-nextprev" reverse>
                <div class="btn-slide-prev hvr" fab small @click="prev">
                  <v-icon color="#5A8B34" size="40">navigate_before</v-icon>
                </div>
                <div class="btn-slide-next hvr" fab small @click="next">
                  <v-icon color="#5A8B34" size="40">navigate_next</v-icon>
                </div>
              </v-card-actions> -->
              <!-- <v-window v-model="onboarding"> -->
                <!-- draggables -->
                <draggable v-model="dragList" @start="saveEl" class="drag-container" :options="{group:'items'}">
                  <div v-for="element in dragList" :key="element" >
                    <div class="btn-blue-dark btn-drag hvr" :class="'animated bounceIn dura-'+element+''" >
                      <span v-html="element"></span>
                    </div>
                  </div>
                </draggable>
              <!-- </v-window>
            </v-card> -->
          </v-flex>
        </v-layout>

        <!-- modal Resultado -->
        <modal-resultado-app v-model="modalresultado" :nameResult="modalResult" :fullscreen="true" @bienAvanzar="bienAction()" @malAvanzar="malAction()">
        </modal-resultado-app>
          <!-- modal tool contenido -->
        <modal-app v-model="modalB" :fullscreen="false" width="700px">
            <template slot="modaltittle">
              <h1 class="modal-icon-title-tool">{{modalToolTitulo[toolNum]}}</h1>
            </template>
            <v-layout row wrap>
              <v-flex xs12 md12>
              <p>{{modalToolText[toolNum]}}</p>
              </v-flex>
            </v-layout>
        </modal-app>
    </div>
</template>
<script>
import nextConditions from "../../js/mixins/nextConditions";
import draggable from 'vuedraggable'
import modalslide1 from '@/pages/unidad1/slide-mod8/modalslide1';
export default {
  mixins: [nextConditions],
  components: {
      draggable,
      modalslide1,
  },
  data() {
    return {
      dialogos: [
      'Preencha a ficha de dados pessoais. Depois, clique em avançar.'
      ],
      length: 14,
      lengthA: 14,
      onboarding: 0,
      onboardingA: 0,
      modalToolTitulo:[
        'Filiação',
        'Naturalidade',
        'Sobrenome', 
        'CEP',
        'CPF é o Cadastro de Pessoas Físicas',
        'RG',
        'Celular',
      ],
      modalToolText:[
        'Nome do pai e nome da mãe.',
        'Lugar onde a pessoa nasceu.',
        'Nome da família. Por exemplo: Soares, Lopes.',
        'Significa Código de Endereçamento Postal. Possui 8 números.',
        'É o número que identifica o pagamento dos impostos de cada pessoa. Possui 11 números.',
        'Registro Geral, é o documento de identidade dos brasileiros. *Para estrangeiros, RNE. Possui 10 números.',
        'Tem 9 dígitos e começa com o número 9.'
      ],
      toolNum:0,
      modalB:false,
      dragList:[
        '148.572.085-04',
        '21/09/1976',
        'Maria Riveira - Rafael Moreira',
        'Carlos',
        'Belo Horizonte',
        'c.moadmin@<br>kmail.com',
        'Administrador',
        'Gerente',
        'Moreira',
        'Rua Álvaro Maia, s/n',
        '69445-970',
        '9 1514 5200',
        '012 345 678-9',
        '5345 6849',
      ],
      correctas:[
        'Carlos',
        'Moreira',
        '21/09/1976',
        'Belo Horizonte',
        'Maria Riveira - Rafael Moreira',
        'Administrador',
        'Gerente',
        'Rua Álvaro Maia, s/n',
        '69445-970',
        '5345 6849',
        '9 1514 5200',
        '012 345 678-9',
        '148.572.085-04',
        'c.moadmin@<br>kmail.com',
      ],
      textDrop:[
        'Nome',
        'Sobrenome',
        'Data de nascimento',
        'Naturalidade',
        'Filiação',
        'Profissão',
        'Cargo',
        'Endereço',
        'CEP',
        'Telefone fixo',
        'Celular',
        'RG',
        'CPF',
        'E-mail'
      ],
      dropList:Array(14).fill([]),
      modalresultado: false,
      modalResult:'mal',
      actualSlot:null,
      todosCorrectos:Array(14).fill(false),
      mostrarBotones:true,
      actualModal:0,
      classHover:false,
      vernxt:false,
      verprv:false,
      realposition:null
    }
  },
  mounted(){
      var x = Math.floor((Math.random() * 14) + 1);
      this.onboarding = x
  },
  watch: {
    onboardingA(value){
      switch (value) {
        case 1:
        case 3:
        case 4:
        case 8:
        case 10:
        case 11:
        case 12:
          this.classHover = true
          break;
        default:
          this.classHover = false
          break;
      }
    }
  },
  methods: {
      openTool(val){
        var actualTool = val
        console.log(actualTool)
        switch (actualTool) {
            case (1):
                this.modalB = true
                this.toolNum = 2
                break;
            case (3):
                this.modalB = true
                this.toolNum = 1
                break; 
            case (4):
                this.modalB = true
                this.toolNum = 0
                break; 
            case (8):
                this.modalB = true
                this.toolNum = 3
                break; 
            case (10):
                this.modalB = true
                this.toolNum = 6
                break; 
            case (11):
                this.modalB = true
                this.toolNum = 5
                break; 
            case (12):
                this.modalB = true
                this.toolNum = 4
                break; 
            default:
                this.modalB = false
                this.toolNum = 0
        }
      },
      nextA () {
        console.log('this.realposition ' +this.realposition)
        console.log('this.onboardingA ' +this.onboardingA)
        this.onboardingA = this.onboardingA + 1 === this.lengthA ? 0 : this.onboardingA + 1
        if(this.realposition < this.onboardingA){
          this.vernxt = false
          this.verprv = true
        }
      },
      prevA () {
        this.onboardingA = this.onboardingA - 1 < 0 ? this.lengthA - 1 : this.onboardingA - 1
        this.vernxt = true
        if(this.onboardingA == 0){
          this.verprv = false
          this.vernxt = true
        }
      },
      saveEl(ev) {
        
      },
      change(ev, slotNum) {
        this.actualSlot = slotNum
        console.log('changed ' + ev.added.element)
        console.log('slotNum ' + slotNum)
        console.log('this.dropList '+ this.dropList)
        if(this.dropList[slotNum] == this.correctas[slotNum]){
          this.realposition = slotNum
        console.log('this.onboardingA '+ this.onboardingA)
        if(this.onboardingA <= 12){
          setTimeout(() => {
            this.nextA ()
            this.$set(this.todosCorrectos,this.actualSlot,true)
            this.verprv= true
          }, 500);
        }else{
          this.mostrarBotones = false
          this.$set(this.todosCorrectos,this.actualSlot,true)
          var todasWordVistos = this.todosCorrectos.every(el => {return el})
          if(todasWordVistos){
            this.$store.commit('nextShow', true);
          }
        }
        }else{
          this.modalresultado = true
          this.modalResult = 'mal'
          this.dragList.push(ev.added.element)
        }
      },
      openModal(){
      this.modal = true
      },
      bienAction(){

      },
      malAction(){
        this.$set(this.dropList,this.actualSlot,'')
        
      },
  }
}
</script>
<style lang="scss" scoped>
// NOT SCOPED !!
@import '../../sass/globals';
.cont-drop{
  margin: 10px 30px;
  padding: 3px;
  border-radius: 10px;
  margin: 0 auto;
  position: relative!important;
  p{
    margin: 0;
    padding: 0;
    color:$ibra-gray;
    font-family: Poppins-Regular;
    font-size: 12px;
  }
}
.drop-correcto{
  background: $ibra-green;
}
.drop-incorrecto{
  background: $ibra-orange;
}

.drag-container{
  width: 100%;
  display: flex;
  flex-flow: wrap;
  justify-content: center;
  align-items: center;
}
.btn-drag{
  width: 100px;
  margin: 2px;
  padding: 3px 2px;
  text-align: center;
  line-height: 15px;
  span{
    font-size: 12px;
    line-height: 9px;
  }
  @media screen and(min-width: 350px){
     width: 120px;
  }
}

.cont-btn-nextprev{
  position: absolute;
  width: 100%;
  margin: 0 auto;
  top: 20%;
  left: 0;
  .btn-slide-next{
    right: -10px;
    position: absolute;
    z-index: 2;
  }
  .btn-slide-prev{
    left: -10px;
    position: absolute;
    z-index: 2;
  }
}
.cont-dialogo{
  background: #81C7FD;
  padding: 10px 20px;
  border-radius: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  p{
    margin: 0;
    padding: 0;
    font-family:Poppins-Regular;
    font-size: 13px;
  }
}
.item-cont{
  border-radius: 20px;
  padding: 10px;
  background: #FFF;
  border: solid #12110B 2px;
  margin-top: 2px;
  width: 100%;
  text-align: center;
  .item-drop{
    background: #FFF;
    border-radius: 4px;
    margin: 0 auto;
    text-align: center;
    span{
      color: black;
      margin: 0;
      padding: 0;
    margin: 0 auto;
    text-align: center;
    }
  }
}
.button-lectura{
  margin-top: 15vh;
  img{
    width: 200px;
  }
}
.cont-titulo-slide{
  background: #12110B;
  padding: 10px;
  border-radius: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  width: 80%;
  p{
    margin: 0;
    padding: 0;
    color: white;
    font-family: 'Poppins-Bold';
  }
}

.modal-icon-title-tool{
  margin: 0;
  padding: 0;
  height: auto;
  font-size: 20px;
  font-family: 'Poppins-Regular';
  line-height: 1em;
  text-align: center;
  margin: 0 auto;
  color: $ibra-dark-blue;
  width: 80%;
}
.tool-hover{
  cursor: pointer;
}
.icon-modal{
  margin-left: 10px;
}
.cont-num{
  font-family: Poppins-Italic;
  font-size: 14px;
  color: $ibra-dark-blue;
  p{
    padding: 0;
    margin: 0;
  }
}
</style>
